// ----------------------------------------------------------------------

import { alpha } from "@mui/material";

export default function DataGrid(theme) {
  return {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          border: `1px solid transparent`,

          "& .MuiTablePagination-root": {
            borderTop: 0,
          },

          "& .MuiDataGrid-cell, .MuiDataGrid-columnsContainer": {
            borderBottom: `1px solid ${theme.palette.divider}`,
          },
          "& .MuiDataGrid-columnSeparator": {
            color: theme.palette.divider,
          },
          '& .MuiDataGrid-columnHeader[data-field="__check__"]': {
            padding: 0,
          },

          "--DataGrid-containerBackground": alpha(
            theme.palette.background.neutral,
            1
          ),
          "& .MuiDataGrid-row--borderBottom ": {
            borderRadius: "9px",
          },
          "& .MuiDataGrid-filterForm": {
            gap: "20px",
          },
          "& .MuiDataGrid-menuList": {
            borderRadius: "8px",
          },
        },
      },
    },

    MuiGridPanelFooter: {
      styleOverrides: {
        root: {
          padding: theme.spacing(2),
          justifyContent: "flex-end",
          "& .MuiButton-root": {
            "&:first-of-type": {
              marginRight: theme.spacing(1.5),
              color: theme.palette.text.primary,
              "&:hover": {
                backgroundColor: theme.palette.action.hover,
              },
            },
            "&:last-of-type": {
              color: theme.palette.common.white,
              backgroundColor: theme.palette.primary.main,
              "&:hover": {
                backgroundColor: theme.palette.primary.dark,
              },
            },
          },
        },
      },
    },
  };
}
